import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";

import Error from "../../../Reports/components/DashboardShared/Error";
import { buyTrackingNumber, updateVoicemailGreeting } from "./services";
import { LeadAssignInfo } from "./shared";

const ConfirmTrackingNumber = ({
  agentId,
  name,
  agents,
  number,
  routingMethod,
  sourceId,
  selectedTextInboundUser,
  shouldCreateLeads,
  fallback,
  selectedFallbackUser,
  voicemailGreetingFile,
  voicemailGreetingFilename,
  onConfirmBuy,
  onClose,
  inboundRecording,
  isEnabledInboundTexts,
  inboundNotificationMessageCondition,
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState("");

  const agentInfo = agents.map((a) => a.name).join(", ");

  const buyNumber = async () => {
    setIsFetching(true);

    const { error: buyError, trackingNumberId } = await buyTrackingNumber(
      agentId,
      name,
      number.value,
      routingMethod,
      isEnabledInboundTexts,
      selectedTextInboundUser,
      agents,
      sourceId,
      shouldCreateLeads,
      fallback,
      selectedFallbackUser,
      voicemailGreetingFilename,
      inboundRecording,
      inboundNotificationMessageCondition,
    );

    if (voicemailGreetingFile !== null) {
      await updateVoicemailGreeting(trackingNumberId, voicemailGreetingFile, voicemailGreetingFilename);
    }

    if (buyError) {
      setError(buyError);
      setIsFetching(false);
    } else {
      onConfirmBuy();
    }
  };

  return (
    <Modal
      show
      onHide={onClose}
      dialogClassName="tw-overflow-y-auto tw-max-h-full"
      contentSize="medium"
      contentClassName="tw-m-auto"
    >
      <Modal.Header title="Confirm tracking number" className="tw-mb-12px" closeButton>
        <Error message={error} show={Boolean(error)} onClose={() => setError("")} />
      </Modal.Header>
      <Modal.Body className="tw-mb-32px">
        <div className="tw-flex tw-flex-col tw-text-gray-75 tw-gap-8px tw-mb-12px">
          <div className="tw-mb-14px">Here&apos;s the details about your new tracking number:</div>
          <ItemSummary title="Tracking Number Name" info={name} />
          <ItemSummary title="Number" info={number.label} />
          <ItemSummary title="Route To" info={agentInfo} />
          <ItemSummary title="Routing Method" info={LeadAssignInfo[routingMethod].pretty} />
        </div>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button size="medium" isLoading={isFetching} onClick={buyNumber}>
          Done
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmTrackingNumber.propTypes = {
  agentId: PropTypes.string.isRequired,
  isEnabledInboundTexts: PropTypes.bool.isRequired,
  selectedTextInboundUser: PropTypes.shape({}).isRequired,
  number: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  name: PropTypes.string.isRequired,
  routingMethod: PropTypes.string.isRequired,
  agents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shouldCreateLeads: PropTypes.bool.isRequired,
  sourceId: PropTypes.string.isRequired,
  onConfirmBuy: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  inboundRecording: PropTypes.string,
  inboundNotificationMessageCondition: PropTypes.string,
  fallback: PropTypes.string.isRequired,
  selectedFallbackUser: PropTypes.shape({}).isRequired,
};

ConfirmTrackingNumber.defaultProps = {
  inboundRecording: "disabled",
  inboundNotificationMessageCondition: "always",
};

export default ConfirmTrackingNumber;

const ItemSummary = ({ title, info }) => (
  <span>
    <strong>{title}: </strong>
    {info}
  </span>
);

ItemSummary.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
};
